import axios from '@/lib/AxApi';

export default {
    selectRow(params, cb)
    {
        axios.get('/AclGroups/selectRow',
            {
                params,
            })
            .then((response) =>
            {
                cb(response.data);
            })
            .catch((e) =>
            {
                // TODO
            });
    },
    saveGroup(params, cb)
    {
        if (typeof params.id !== 'undefined' && params.id != '')
        {
            axios.post('/AclGroups/updateRow', params)
                .then((response) =>
                {
                    cb(response.data);
                })
                .catch((e) =>
                {
                    // TODO
                });
        }
        else
        {
            axios.post('/AclGroups/insertRow', params)
                .then((response) =>
                {
                    cb(response.data);
                })
                .catch((e) =>
                {
                    // TODO
                });
        }
    },
    deleteGroup(params, cb)
    {
        axios.post('/AclGroups/deleteRow', params)
            .then((response) =>
            {
                cb(response.data);
            })
            .catch((e) =>
            {
                // TODO
            });
    },
};
